/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-key */
import React, { useState, useEffect, useContext } from 'react';
import DashboardSidebar from "../../sidebar/index.jsx";
import Footer from "../../home/footer.jsx";
import { doctordashboardprofile02 } from '../../imagepath';
import { Link, useLocation, useParams } from 'react-router-dom';
import { getOrderById } from '../../../services/orderService';
import { AuthContext } from '../../../context/AuthContext';
import { updateShoutoutStatus, markShoutoutAsDone } from '../../../services/celebShoutouts';
import { toast } from 'react-toastify';
import Navbar from '../../landingpage/sections/Navbar/index.jsx';

// Cloudinary configuration
const CLOUD_NAME = "dcyzivpw4";
const UPLOAD_PRESET = "howzitone";

const OrderStart = (props) => {
    const { user } = useContext(AuthContext);
    const location = useLocation();
    const { orderId } = useParams();
    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isUpdating, setIsUpdating] = useState(false);
    const [videoUrl, setVideoUrl] = useState('');
    const [isCompleting, setIsCompleting] = useState(false);
    const [uploadingVideo, setUploadingVideo] = useState(false);
    const [videoFile, setVideoFile] = useState(null);
    const [videoPreview, setVideoPreview] = useState(null);

    useEffect(() => {
        const fetchOrderData = async () => {
            try {
                setLoading(true);

                if (location.state?.order) {
                    setOrder(location.state.order);
                    setLoading(false);
                    return;
                }

                if (orderId) {
                    const response = await getOrderById(orderId);
                    setOrder(response.data);
                    setLoading(false);
                    return;
                }

                setError("No order data provided");

            } catch (err) {
                setError(err.message || "Failed to load order details");
                console.error("Error:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchOrderData();
    }, [location.state, orderId]);


    const handleAcceptOrder = async () => {
        if (order.status !== 'pending') {
            alert('This order is already processed.');
            return;
        }

        try {
            setIsUpdating(true);
            const response = await updateShoutoutStatus(order._id, "accepted");

            setOrder(prevOrder => ({
                ...response.data,
                user: prevOrder.user,
                userId: prevOrder.userId
            }));

        } catch (error) {
            alert(error.message || "Failed to accept order");
        } finally {
            setIsUpdating(false);
        }
    };

    const handleRejectOrder = async () => {
        if (order.status !== 'pending') {
            alert('This order is already processed.');
            return;
        }

        try {
            setIsUpdating(true);
            const response = await updateShoutoutStatus(order._id, "declined");

            // Preserve user data when updating the order
            setOrder(prevOrder => ({
                ...response.data,
                user: prevOrder.user,        // Preserve user data
                userId: prevOrder.userId     // Preserve userId
            }));

        } catch (error) {
            alert(error.message || "Failed to reject order");
        } finally {
            setIsUpdating(false);
        }
    };

    const handleVideoFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Validate file type
        if (!file.type.startsWith('video/')) {
            toast.error('Please select a video file');
            return;
        }

        // Validate file size (max 100MB)
        if (file.size > 100 * 1024 * 1024) {
            toast.error('Video size should be less than 100MB');
            return;
        }

        setVideoFile(file);

        // Create preview
        const previewUrl = URL.createObjectURL(file);
        setVideoPreview(previewUrl);

        // Clear URL input when file is selected
        setVideoUrl('');
    };

    const uploadVideoToCloudinary = async (file) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("upload_preset", UPLOAD_PRESET);
        formData.append("folder", "howzit/shoutouts");
        formData.append("resource_type", "video");

        const response = await fetch(
            `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/video/upload`,
            {
                method: "POST",
                body: formData,
            }
        );

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error?.message || 'Video upload failed');
        }

        if (data.secure_url) {
            return data.secure_url;
        } else {
            throw new Error('Video upload failed: No URL returned');
        }
    };

    const handleCompleteShoutout = async () => {
        let finalVideoUrl = videoUrl;

        // If a file is selected, upload it to Cloudinary
        if (videoFile) {
            try {
                setUploadingVideo(true);
                finalVideoUrl = await uploadVideoToCloudinary(videoFile);
                toast.success('Video uploaded successfully!');
            } catch (error) {
                toast.error(error.message || 'Failed to upload video');
                return;
            } finally {
                setUploadingVideo(false);
            }
        }

        if (!finalVideoUrl) {
            toast.error('Please provide a video URL or upload a video file');
            return;
        }

        try {
            setIsCompleting(true);
            const response = await markShoutoutAsDone(order._id, finalVideoUrl);

            // Preserve user data when updating the order
            setOrder(prevOrder => ({
                ...response.data.shoutout,
                user: response.data.shoutout?.user || prevOrder.user, // Preserve user data
                userId: response.data.shoutout?.userId || prevOrder.userId
            }));

            // Show success modal
            if (window.$) {
                window.$('#end_session').modal('show');
            }
        } catch (error) {
            toast.error(error.message || "Failed to complete shoutout");
        } finally {
            setIsCompleting(false);
        }
    };

    // const handleCompleteShoutout = async () => {
    //     let finalVideoUrl = videoUrl;

    //     // If a file is selected, upload it to Cloudinary
    //     if (videoFile) {
    //         try {
    //             setUploadingVideo(true);
    //             finalVideoUrl = await uploadVideoToCloudinary(videoFile);
    //             toast.success('Video uploaded successfully!');
    //         } catch (error) {
    //             toast.error(error.message || 'Failed to upload video');
    //             return;
    //         } finally {
    //             setUploadingVideo(false);
    //         }
    //     }

    //     if (!finalVideoUrl) {
    //         toast.error('Please provide a video URL or upload a video file');
    //         return;
    //     }

    //     try {
    //         setIsCompleting(true);
    //         const response = await markShoutoutAsDone(order._id, finalVideoUrl);
    //         setOrder(response.data.shoutout);

    //         // Show success modal
    //         if (window.$) {
    //             window.$('#end_session').modal('show');
    //         }
    //     } catch (error) {
    //         toast.error(error.message || "Failed to complete shoutout");
    //     } finally {
    //         setIsCompleting(false);
    //     }
    // };

    const formatDate = (dateString) => {
        const options = {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    if (loading) {
        return <div className="loading-screen">Loading Order...</div>;
    }

    if (error || !order) {
        return (
            <div className="error-screen">
                <h2>Order Not Found</h2>
                <p>{error}</p>
                <Link to="/dashboard" className="btn btn-primary">
                    Back to Dashboard
                </Link>
            </div>
        );
    }

    const getYouTubeId = (url) => {
        if (url.includes('youtube.com/watch?v=')) {
            const videoId = url.split('v=')[1];
            const ampersandPosition = videoId.indexOf('&');
            return ampersandPosition !== -1 ? videoId.substring(0, ampersandPosition) : videoId;
        } else if (url.includes('youtu.be/')) {
            return url.split('youtu.be/')[1];
        }
        return null;
    };

    return (
        <div className='main-wrapper'>
            <Navbar {...props} />

            {/* Breadcrumb */}
            <div className="breadcrumb-bar">
                <div className="container">
                    <div className="row align-items-center inner-banner">
                        <div className="col-md-12 col-12 text-center">
                            <h2 className="breadcrumb-title">Order Detail</h2>
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item active">Order Detail</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Page Content */}
            <div className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-xl-3 theiaStickySidebar">
                            <DashboardSidebar />
                        </div>

                        <div className="col-lg-8 col-xl-9">
                            <div className="dashboard-header">
                                <div className="header-back">
                                    <Link to="/dashboard" className="back-arrow">
                                        <i className="fa-solid fa-arrow-left" />
                                    </Link>
                                    <h3>Order Details</h3>
                                </div>
                            </div>

                            <div className="appointment-details-wrap">
                                {/* Order Details Card */}
                                <div className="appointment-wrap appointment-detail-card">
                                    <ul>
                                        <li>
                                            <div className="patinet-information">
                                                <img
                                                    src={order.user?.profilepicture || doctordashboardprofile02}
                                                    alt="Fan profile"
                                                    onError={(e) => e.target.src = doctordashboardprofile02}
                                                />
                                                <div className="patient-info">
                                                    <p>Fan ID: #{order.user?._id?.slice(-6).toUpperCase() || 'N/A'}</p>
                                                    <h6>{order.user?.fullName || 'Unknown Fan'}</h6>
                                                    <div className="mail-info-patient">
                                                        <ul>
                                                            <li>
                                                                <i className="fa-solid fa-user" />
                                                                {order.user?.userPhone || 'Phone not provids'}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>

                                        <li className="appointment-info">
                                            <div className="person-info">
                                                <p>Type of Shoutout</p>
                                                <ul className="d-flex apponitment-types">
                                                    <li>
                                                        <i className="fa-solid fa-video text-green" />
                                                        Video Shoutout
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>

                                        <li className="appointment-action">
                                            <div className="detail-badge-info">
                                                <span className={`badge ${order.status === 'pending' ? 'bg-warning' :
                                                    order.status === 'accepted' ? 'bg-info' :
                                                        order.status === 'completed' ? 'bg-success' : 'bg-secondary'
                                                    }`}>
                                                    {order.status?.toUpperCase()}
                                                </span>
                                            </div>
                                        </li>
                                    </ul>

                                    <ul className="detail-card-bottom-info">
                                        <li><h6>Order created on</h6><span>{formatDate(order.createdAt)}</span></li>
                                        <li><h6>To be delivered on</h6><span>{formatDate(order.deliveryDate)}</span></li>
                                        <li><h6>Recipient Name</h6><span>{order.recipientName || 'Not specified'}</span></li>
                                    </ul>

                                    <ul className="detail-card-bottom-info">
                                        <li><h6>Shoutout Message</h6>{order.message || "No specific message provided"}</li>
                                    </ul>
                                </div>

                                {/* Action Section Based on Status */}
                                {order.status === 'pending' && (
                                    <div className="accept-reject-buttons mt-4">
                                        <h5 className="head-text">Respond to Order Request</h5>
                                        <div className="d-flex gap-3">
                                            <button className="btn btn-success" onClick={handleAcceptOrder} disabled={isUpdating}>
                                                {isUpdating ? 'Accepting...' : 'Accept Order'}
                                            </button>
                                            <button className="btn btn-danger" onClick={handleRejectOrder} disabled={isUpdating}>
                                                {isUpdating ? 'Reject' : 'Reject Order'}
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {order.status === 'accepted' && (
                                    <div className="create-appointment-details">
                                        <div className="session-end-head">
                                            <h6>
                                                <span>Order expires in </span>
                                                {order.deliveryDate ? (
                                                    `${Math.ceil((new Date(order.deliveryDate) - new Date()) / (1000 * 60 * 60 * 24))} days`
                                                ) : 'Date not specified'}
                                            </h6>
                                        </div>
                                        <h5 className="head-text">Upload Video Shoutout</h5>
                                        <div className="create-details-card">
                                            <div className="create-details-card-body">
                                                <form>
                                                    {/* Video URL Input Field */}
                                                    <div className="col-md-12">
                                                        <div className="form-wrap">
                                                            <label className="col-form-label">
                                                                Paste Video URL (YouTube, Vimeo, etc.)
                                                            </label>
                                                            <input
                                                                type="url"
                                                                className="form-control"
                                                                placeholder="https://www.youtube.com/watch?v=..."
                                                                value={videoUrl}
                                                                onChange={(e) => {
                                                                    setVideoUrl(e.target.value);
                                                                    if (e.target.value) {
                                                                        setVideoFile(null);
                                                                        setVideoPreview(null);
                                                                    }
                                                                }}
                                                            />
                                                            <small className="form-text text-muted">
                                                                Paste the video link from any platform
                                                            </small>
                                                        </div>
                                                    </div>

                                                    {/* OR separator */}
                                                    <div className="col-md-12 mt-3 mb-3 text-center">
                                                        <span className="text-muted">OR</span>
                                                    </div>

                                                    {/* Video File Upload Section */}
                                                    <div className="col-md-12">
                                                        <div className="form-wrap">
                                                            <label className="col-form-label">Upload Video File</label>
                                                            <div className="drop-file">
                                                                <p>Drop video file or Click to upload</p>
                                                                <input
                                                                    type="file"
                                                                    accept="video/*"
                                                                    onChange={handleVideoFileChange}
                                                                    disabled={uploadingVideo}
                                                                />
                                                                {uploadingVideo && (
                                                                    <div className="mt-2">
                                                                        <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
                                                                            <span className="visually-hidden">Uploading...</span>
                                                                        </div>
                                                                        <small className="text-muted">Uploading video...</small>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="view-imgs">
                                                                {videoFile && (
                                                                    <div className="view-img">
                                                                        <i className="fa-solid fa-video" />
                                                                        <span>{videoFile.name}</span>
                                                                        <span className="file-size">
                                                                            {(videoFile.size / (1024 * 1024)).toFixed(2)} MB
                                                                        </span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <small className="form-text text-muted">
                                                                Supported formats: MP4, MOV, AVI, etc. Max size: 20MB
                                                            </small>
                                                        </div>
                                                    </div>

                                                    {/* Video Preview */}
                                                    {(videoUrl || videoPreview) && (
                                                        <div className="col-md-12 mt-3">
                                                            <div className="video-preview-container" style={{
                                                                border: '1px solid #e0e0e0',
                                                                borderRadius: '8px',
                                                                padding: '12px',
                                                                backgroundColor: '#f8f9fa'
                                                            }}>
                                                                <h6 style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#333' }}>
                                                                    Video Preview
                                                                </h6>

                                                                {/* YouTube iframe */}
                                                                {videoUrl && (videoUrl.includes('youtube.com/') || videoUrl.includes('youtu.be/')) ? (
                                                                    <div style={{
                                                                        position: 'relative',
                                                                        paddingBottom: '56.25%', // 16:9 aspect ratio
                                                                        height: '0',
                                                                        overflow: 'hidden',
                                                                        borderRadius: '6px'
                                                                    }}>
                                                                        <iframe
                                                                            src={`https://www.youtube.com/embed/${getYouTubeId(videoUrl)}`}
                                                                            title={`YouTube video preview for order ${order._id}`}
                                                                            style={{
                                                                                position: 'absolute',
                                                                                top: '0',
                                                                                left: '0',
                                                                                width: '100%',
                                                                                height: '100%',
                                                                                border: 'none',
                                                                                borderRadius: '6px'
                                                                            }}
                                                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                            allowFullScreen
                                                                        />
                                                                    </div>
                                                                ) : videoPreview ? (
                                                                    /* Local video preview */
                                                                    <div style={{
                                                                        position: 'relative',
                                                                        paddingBottom: '56.25%', // 16:9 aspect ratio
                                                                        height: '0',
                                                                        overflow: 'hidden',
                                                                        borderRadius: '6px'
                                                                    }}>
                                                                        <video
                                                                            src={videoPreview}
                                                                            controls
                                                                            style={{
                                                                                position: 'absolute',
                                                                                top: '0',
                                                                                left: '0',
                                                                                width: '100%',
                                                                                height: '100%',
                                                                                border: 'none',
                                                                                borderRadius: '6px'
                                                                            }}
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    /* Generic video link preview for non-YouTube */
                                                                    <div style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '12px',
                                                                        padding: '10px',
                                                                        backgroundColor: 'white',
                                                                        borderRadius: '6px'
                                                                    }}>
                                                                        <div style={{
                                                                            width: '60px',
                                                                            height: '60px',
                                                                            backgroundColor: '#007bff',
                                                                            borderRadius: '6px',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            color: 'white',
                                                                            fontSize: '24px'
                                                                        }}>
                                                                            <i className="fa-solid fa-play"></i>
                                                                        </div>
                                                                        <div style={{ flex: 1 }}>
                                                                            <p style={{
                                                                                margin: '0 0 4px 0',
                                                                                fontSize: '12px',
                                                                                color: '#666',
                                                                                overflow: 'hidden',
                                                                                textOverflow: 'ellipsis',
                                                                                whiteSpace: 'nowrap'
                                                                            }}>
                                                                                {videoUrl}
                                                                            </p>
                                                                            <a
                                                                                href={videoUrl}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                style={{
                                                                                    fontSize: '12px',
                                                                                    color: '#007bff',
                                                                                    textDecoration: 'none'
                                                                                }}
                                                                            >
                                                                                <i className="fa-solid fa-arrow-up-right-from-square me-1"></i>
                                                                                Open video in new tab
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div className="col-md-12 mt-4">
                                                        <div className="form-set-button">
                                                            <button
                                                                className="btn btn-light"
                                                                type="button"
                                                                onClick={() => {
                                                                    setVideoUrl('');
                                                                    setVideoFile(null);
                                                                    setVideoPreview(null);
                                                                }}
                                                            >
                                                                Clear
                                                            </button>
                                                            <button
                                                                className="btn btn-primary"
                                                                type="button"
                                                                onClick={handleCompleteShoutout}
                                                                disabled={isCompleting || uploadingVideo || (!videoUrl && !videoFile)}
                                                            >
                                                                {isCompleting ? 'Processing...' : 'Save & Send Shoutout'}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {(order.status === 'completed' || order.status === 'rejected') && (
                                    <div className="alert alert-info mt-4">
                                        <i className="fa-solid fa-info-circle"></i>
                                        This order has been {order.status}.
                                        {order.status === 'completed' && ' The video has been delivered to the fan.'}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
            {/* Success Modal */}
            <div className="modal fade info-modal" id="end_session">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="success-wrap">
                                <div className="success-info">
                                    <div className="text-center">
                                        <span className="icon-success bg-blue">
                                            <i className="fa-solid fa-check" />
                                        </span>
                                        <h3>Shoutout Ready!</h3>
                                        <p>Your video shoutout has been prepared successfully</p>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-btn text-center">
                                <Link to="/dashboard" className="btn btn-gray me-1" data-bs-dismiss="modal">
                                    Back to Dashboard
                                </Link>
                                <Link to="/dashboard" className="btn btn-primary prime-btn" data-bs-dismiss="modal">
                                    View All Orders
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderStart;